import script from "./CreateMethod.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateMethod.vue?vue&type=script&setup=true&lang=ts"

import "./CreateMethod.vue?vue&type=style&index=0&id=56624d85&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56624d85"]])

export default __exports__